import { createSlice } from "@reduxjs/toolkit";
import {
  allowedUsers,
  permissionsForEC,
  permissionsForEU,
} from "../../constants/constants";
import { getObjKeyByValue } from "../../utils/Utilities";

let tempObjEU = {};
Object.keys(permissionsForEU).forEach((item) => {
  tempObjEU[item] = "";
});
let tempObjEC = {};
Object.keys(permissionsForEC).forEach((item) => {
  tempObjEC[item] = "";
});
const initialState = {
  EU: {
    ...tempObjEU,
  },
  EC: {
    ...tempObjEC,
  },
};

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    getPermissionsForEU: (state, actions) => {
      actions.payload.forEach((item) => {
        if (item.type?.toLowerCase() === allowedUsers[0]?.toLowerCase()) {
          let keyName = getObjKeyByValue(permissionsForEU, item.claimKey) || "";
          if (keyName) state.EU[keyName] = item.claimKey;
        }
      });
    },
    getPermissionsForEC: (state, actions) => {
      actions.payload.forEach((item) => {
        if (item.type?.toLowerCase() === allowedUsers[1]?.toLowerCase()) {
          let keyName = getObjKeyByValue(permissionsForEC, item.claimKey) || "";
          if (keyName) state.EC[keyName] = item.claimKey;
        }
      });
    },
  },
});

export const { getPermissionsForEU, getPermissionsForEC } =
  permissionsSlice.actions;

export default permissionsSlice.reducer;
